import { KYMW1407Model } from '../kymw1407.model';
import { GetImageListModel } from '../../kymw1400/vo/get-image-list.model';
import { Injectable } from "@angular/core";
import { PlessHttp } from '../../../../shared/http/pless-http.service';
import { PlessDialogServiceSub } from '../../../../commons/kymw00/pless-dialog-service-sub';
import { PlessJsonResponderSub } from 'src/app/commons/kymw00/pless-json-responder-sub.service';
import { PlessRequest } from 'src/app/shared/vo/pless-request.model';

/**
 * 画像リストを取得する。
 *
 * @export
 * @class GetImageListService
 * @extends {PlessResponderSub}
 */
@Injectable()
export class GetImageListService extends PlessJsonResponderSub<any> {

  private model: KYMW1407Model = null;
  private vo: GetImageListModel = null;

  constructor(
    protected plessHttp: PlessHttp,
    protected dialogService: PlessDialogServiceSub
  ) {
    super(plessHttp, dialogService);
  }

  /**
   * bodyにセットする値を返す
   *
   * @private
   * @returns {PlessRequest} リクエストJSON
   * @memberof GetImageListService
   */
  private getBody(): PlessRequest {
    return new PlessRequest({
      parameter: {
        KomaId: this.vo.komaID
      }
    });
  }

  /**
   * API呼び出し
   *
   * @param {KYMW1407Model} model
   * @param {GetImageListModel} vo
   * @memberof GetImageListService
   */
  execute(model: KYMW1407Model, vo: GetImageListModel) {
    this.model = model;
    this.vo = vo;
    this.send('KYMW14getImageList', this.getBody());
  }

  /**
   * API通信成功時の処理
   *
   * @param {*} data レスポンスデータ
   * @memberof GetImageListService
   */
  success(data: any) {
    this.model.updateImageList(data);
  }
}
